import Vue from 'vue';
import vueModal from './index.vue';
let vueModalDom = Vue.extend(vueModal);
function closeModal(){
    let existEle = document.querySelector("#vue-modal");
    if (existEle) {
        document.body.removeChild(existEle);
    }
};
const Modal = (option,submit,cancel) => {
    let opt = {
        title:'',
        tip:'',
        cancel:true,
        cancelText:'取消',
        submitText:'确定',
    };
    for(let property in option){
        opt[property] = option[property];  // 使用 option 的配置
    };
    let instance = new vueModalDom({
        data:()=>{
            return opt;
        },
        methods:{
            submitMethod(){
                submit && submit();
            },
            cancelMethod(){

                cancel && cancel();
            }
        }
    })
    instance.$mount();
    document.body.appendChild(instance.$el);
    return instance;
}

let install = (Vue)=>{
    Vue.prototype.$modal = Modal;
    Vue.prototype.$modal.close = closeModal;
}

export default install;



// WEBPACK FOOTER //
// ./src/components/vue-modal/index.js